import { render } from "./FacebookIcon.vue?vue&type=template&id=383d35d8"
import script from "./FacebookIcon.vue?vue&type=script&lang=js"
export * from "./FacebookIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__